import classNames from "classnames";
import { VerticalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";
import React from "react";
import { focusOnMount } from "utilities/reactUtils";

interface Props {
  selected: boolean
  value?: any
  onClick: (clickedValue?: any) => void
  textClassNames?: string
  autoFocus?: boolean
  group?: string
}

const SelectableDiv = (props: React.PropsWithChildren<Props>) => {
  const classes = classNames("selectable-div", {
    "selectable-div-selected": props.selected
  });

  const textClassNames = classNames("selectable-div-text", props.textClassNames);

  const onKeyPress: React.KeyboardEventHandler<HTMLDivElement> = e => {
    if (e.key === " ") {
      e.preventDefault();
      props.onClick(props.value);
    }
  };

  return <div
    {...VerticalKeyboardNavigationGroup(props.group)}
    ref={props.autoFocus ? focusOnMount : undefined}
    tabIndex={0}
    className={classes}
    onClick={() => { props.onClick(props.value); }}
    onKeyDown={onKeyPress}
  >
    <div className={textClassNames}>
      {props.children}
    </div>
  </div>;
};

export default SelectableDiv;